// extracted by mini-css-extract-plugin
export default {"root":"Rating_root__J5-zf","star":"Rating_star__GtXrU","candidate":"Rating_candidate__YfvG0"};